import CollectionsIcon from '@mui/icons-material/Collections';
import Box from '@mui/material/Box';
import { alpha, type Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import type React from 'react';
import { BoxImageStyles, ImageWrapperStyles } from 'src/components/CommonStyles/ImageDiv/ImageDivStyles';

type EmptyCollectionThumbnailProps = {
  variant?: 'default' | 'compact';
};

const useStyles = makeStyles((theme: Theme) => ({
  patternBackground: {
    width: '100%',
    height: '100%',
    backgroundColor: theme.palette.common.black,
    backgroundImage: `repeating-linear-gradient(45deg, ${alpha(theme.palette.text.primary, 0.025)} 0px, ${alpha(
      theme.palette.text.primary,
      0.025,
    )} 1px, transparent 1px, transparent 14px)`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  chip: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    padding: '8px 14px',
    borderRadius: 4,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
  },
  chipIcon: {
    fontSize: 20,
    color: theme.palette.text.secondary,
  },
  chipLabel: {
    textTransform: 'uppercase',
    letterSpacing: '0.06em',
    color: theme.palette.text.secondary,
    lineHeight: 1,
  },
  compactIcon: {
    fontSize: 16,
    color: theme.palette.text.secondary,
    opacity: 0.55,
  },
}));

const EmptyCollectionThumbnail: React.FC<EmptyCollectionThumbnailProps> = ({ variant = 'default' }) => {
  const classes = useStyles();

  return (
    <ImageWrapperStyles role="img" aria-label="Empty gallery">
      <BoxImageStyles>
        <div className={classes.patternBackground}>
          {variant === 'compact' ? (
            <CollectionsIcon className={classes.compactIcon} />
          ) : (
            <Box className={classes.chip}>
              <CollectionsIcon className={classes.chipIcon} />
              <Typography variant="caption" className={classes.chipLabel}>
                EMPTY
              </Typography>
            </Box>
          )}
        </div>
      </BoxImageStyles>
    </ImageWrapperStyles>
  );
};

export default EmptyCollectionThumbnail;
